import React from 'react'
import { FormattedMessage } from 'react-intl'

import { MEETING_FORMATS } from '@lyrahealth-inc/shared-app-logic/src/models/session/Session'

import { ClientFiltersCheckboxSection } from './ClientFiltersCheckboxSection'

const ClientFilterMeetingFormats = {
  IN_PERSON: MEETING_FORMATS.IN_PERSON,
  VIDEO: MEETING_FORMATS.VIDEO,
  LIVE_MESSAGING: MEETING_FORMATS.LIVE_MESSAGING,
}

export type ClientFilterMeetingFormats = (typeof ClientFilterMeetingFormats)[keyof typeof ClientFilterMeetingFormats]

export type ClientFiltersModalitySectionProps = {
  values: ClientFilterMeetingFormats[]
  onChange: (values: ClientFilterMeetingFormats[]) => void
  isEngageProvider?: boolean
}

export const ClientFiltersModalitySection: React.FC<ClientFiltersModalitySectionProps> = ({
  values,
  onChange,
  isEngageProvider,
}) => {
  const formatsToShow = isEngageProvider
    ? [ClientFilterMeetingFormats.IN_PERSON, ClientFilterMeetingFormats.VIDEO]
    : Object.values(ClientFilterMeetingFormats)

  return (
    <ClientFiltersCheckboxSection
      title={<FormattedMessage defaultMessage='Modality' description='Modality filter section' />}
      items={formatsToShow.map((value) => ({
        id: value,
        text: (() => {
          switch (value) {
            case ClientFilterMeetingFormats.IN_PERSON:
              return (
                <FormattedMessage
                  defaultMessage='In person'
                  description='Label for filtering conversations by In Person modality'
                />
              )
            case ClientFilterMeetingFormats.VIDEO:
              return (
                <FormattedMessage
                  defaultMessage='Video'
                  description='Label for filtering conversations by video modality'
                />
              )
            case ClientFilterMeetingFormats.LIVE_MESSAGING:
              return (
                <FormattedMessage
                  defaultMessage='Live messaging'
                  description='Label for filtering conversations by live messaging modality'
                />
              )
            default:
              return value
          }
        })(),
      }))}
      values={values}
      onChange={onChange}
      name='modality'
    />
  )
}
